import { render, staticRenderFns } from "./FleetSmsRevisions.vue?vue&type=template&id=b0299732&scoped=true&"
import script from "./FleetSmsRevisions.vue?vue&type=script&lang=js&"
export * from "./FleetSmsRevisions.vue?vue&type=script&lang=js&"
import style0 from "./FleetSmsRevisions.vue?vue&type=style&index=0&id=b0299732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0299732",
  null
  
)

export default component.exports